import { passengerTypes } from './config'

export const getDefaultFerryOptions = (ferries, routes) => {
  const defaultFerryId = ferries?.[0]?.value || ''
  const defaultDeparture =
    routes?.[defaultFerryId]?.availableOutward?.[0]?.value || ''

  const firstReturnOptions =
    routes?.[defaultFerryId]?.availableReturn?.[0]?.value
  const secondOutWard =
    routes?.[defaultFerryId]?.availableOutward?.[1]?.value || ''
  const defaultReturn =
    firstReturnOptions && firstReturnOptions !== defaultDeparture
      ? firstReturnOptions
      : secondOutWard
      ? secondOutWard
      : ''

  return {
    defaultFerryId,
    defaultDeparture,
    defaultReturn,
  }
}

export const getTotalGuestCount = values => {
  if (values.activeTab === 'stay') {
    return values?.hotelGuests?.reduce(
      (num, room) => num + room.adults + room.children,
      0,
    )
  }

  if (!values.passengers || !Object.keys(values.passengers)?.length) {
    return null
  }

  const directionCounts = Object.entries(values.passengers).reduce(
    (obj, [direction, counts]) => {
      const total =
        counts && Object.keys(counts)?.length
          ? Object.values(counts).reduce((num, { count }) => num + count, 0)
          : 0

      return {
        ...obj,
        [direction]: total,
      }
    },
    {},
  )
  return values.journeyType === 'oneWay'
    ? directionCounts?.departure
    : Object.values(directionCounts || {})?.length
    ? Math.max(...Object.values(directionCounts || {}))
    : 0
}

export const onCalendarOpen = calendar => {
  const { top, bottom } = calendar.getBoundingClientRect()
  const { innerHeight } = window
  if (top < 0 || bottom > innerHeight) {
    calendar.scrollIntoView({ behavior: 'smooth', block: 'end' })
  }
}

export const passengersToParams = passengers =>
  Object.entries(passengers || {}).reduce(
    (acc, [direction, passengers]) => ({
      ...acc,
      [`${direction}Passengers`]: Object.values(passengers).reduce(
        (str, type, idx, arr) => {
          return (
            str + `${type.count}|${type.type}${idx < arr.length - 1 ? ',' : ''}`
          )
        },
        '',
      ),
    }),
    {},
  )

export const knownHotelChildTypes = ['C', 'I']

export const convertFerryPassengersToHotelGuests = passengers => {
  if (!passengers || !Object.keys(passengers || {})?.length) {
    return [
      {
        adults: 1,
        children: 0,
      },
    ]
  }

  return [
    Object.values(passengers).reduce(
      (obj, passengerCount) => {
        const key = knownHotelChildTypes?.some(
          code => code === passengerCount.type,
        )
          ? 'children'
          : 'adults'

        return {
          ...obj,
          [key]: obj[key] + passengerCount.count,
        }
      },
      { adults: 0, children: 0 },
    ),
  ]
}

export const convertHotelGuestsToFerryPassengers = ({ rooms }) => {
  const adultTicket = passengerTypes?.find(({ type }) => type === 'A') || {}
  const childTicket = passengerTypes?.find(({ type }) => type === 'C') || {}

  const totals = rooms.reduce(
    (obj, room) => ({
      adults: obj.adults + +room.adults,
      children: obj.children + +room.children,
    }),
    {
      adults: 0,
      children: 0,
    },
  )

  return {
    [adultTicket?.code || 'adults']: {
      ...adultTicket,
      count: totals.adults || 1,
    },
    [childTicket.code || 'children']: {
      ...childTicket,
      count: totals.children || 0,
    },
  }
}
